export default {"src":"/_next/static/media/CosmeticConcerns.4b35389c.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};